import React, {Component} from 'react';
import Camera from '../../components/camera/Camera';
import './testing.css';

import CameraWithFraming  from '../camera_with_framing/CameraWithFraming';

class Testing extends Component {

    render() {
        return (
            <div className={'testing'}>
                <CameraWithFraming stepInfo={{icon:'ci-back'}}/>
            </div>
        );
    }
}

export default Testing;
